import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from '../../../redux/thunks/auth';

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  return <></>;
};

export default Logout;
